/**
 * Lanzador del asistente Clara inyectado en el documento del orquestador
 * (id alineado con app-contenido-contactanos del shell nwa-ms_front-web-afp).
 */
export const CLARA_CHAT_LAUNCHER_ID = "custom-chat-launcher";

/** Simula el click en el FAB de Clara para abrir el chat. @returns true si existía el elemento */
export function openClaraChatLauncher(): boolean {
  const launcher = globalThis.document?.getElementById(
    CLARA_CHAT_LAUNCHER_ID,
  ) as HTMLButtonElement | null;
  if (launcher) {
    launcher.click();
    return true;
  }
  return false;
}
